<template>
  <preview-sp class="pega-sp-print-area">
    <interview-preview-detail-sp :interview="interview" />
  </preview-sp>
</template>

<script>
import InterviewPreviewDetailSp from '@/components/organisms/InterviewPreviewDetailSp'
import PreviewSp from '@/components/templates/PreviewSp'
import interviewPreviewCommon from '@/lib/interviewPreviewCommon'
export default {
  components: {
    PreviewSp,
    InterviewPreviewDetailSp
  },
  // PC・SP共通処理読み込み
  mixins: [interviewPreviewCommon]
}
</script>
